<template>
  <div class="field-wrapper field-wrapper--large" :class="['field-wrapper--' + field.type]">
    <div class="field-group field-group--html">
      <div v-html="field.content.replace('--vehicleName--', vehicleName)"></div>
    </div>
  </div>
</template>

<script>
import store from '../store';
export default {
  store,
  name: "VFieldHtml",
  data () {
    return {}
  },
  props: {
    formId: Number,
    field: Object,
    fieldKey: Number,
    vehicleName: String
  }
}
</script>
